import React, { useState } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import { border } from "@mui/system";
import { CloseWhiteIcon } from "../../../styles/img/svg/CloseWhiteIcon";
import UiLanguageFonts from "../../_uiComponents/UiLanguageFonts";

export const UiPopup = (props) => {
  return (
    <>
      <Modal
        open={props.openModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            props.handleClose();
          }
        }}
        className="df-centerd-modal"
      >
        <Box className="df-commmon-modal">
          {props.showCloseIcon && (
            <div
              onClick={props.handleClose}
              className="df-centerd-modal__close"
            >
              <CloseWhiteIcon />
            </div>
          )}

          <UiLanguageFonts> {props.children}</UiLanguageFonts>
        </Box>
      </Modal>
    </>
  );
};

export const UiProfileUploadPopup = (props) => {
  return (
    <>
      <Modal
        open={props.openModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            props.handleClose();
          }
        }}
        className="df-centerd-modal"
      >
        <Box className="df-profile-image-modal">
          {props.showCloseIcon && (
            <div
              onClick={props.handleClose}
              className="df-centerd-modal__close"
            >
              <CloseWhiteIcon />
            </div>
          )}

          <UiLanguageFonts> {props.children}</UiLanguageFonts>
        </Box>
      </Modal>
    </>
  );
};

export const UiOtpPopup = (props) => {
  return (
    <>
      <Modal
        open={props.openModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            props.handleClose();
          }
        }}
        className="df-centerd-modal"
      >
        <Box className="df-otp-modal">
          {props.showCloseIcon && (
            <div
              data-testid="otp-modal-close-button"
              onClick={props.handleClose}
              className="df-centerd-modal__close"
            >
              <CloseWhiteIcon />
            </div>
          )}

          <UiLanguageFonts> {props.children}</UiLanguageFonts>
        </Box>
      </Modal>
    </>
  );
};

export const ProfileUploadPopup = (props) => {
  return (
    <>
      <Modal
        open={props.openModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            props.handleClose();
          }
        }}
        className="df-centerd-modal"
      >
        <Box className="df-profile-image-modal">
          {props.showCloseIcon && (
            <div
              onClick={props.handleClose}
              className="df-centerd-modal__close"
            >
              <CloseWhiteIcon />
            </div>
          )}

          <UiLanguageFonts> {props.children}</UiLanguageFonts>
        </Box>
      </Modal>
    </>
  );
};

export const OtpPopup = (props) => {
  return (
    <>
      <Modal
        open={props.openModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            props.handleClose();
          }
        }}
        className="df-centerd-modal"
      >
        <Box className="df-otp-modal">
          {props.showCloseIcon && (
            <div
              data-testid="otp-modal-close-button"
              onClick={props.handleClose}
              className="df-centerd-modal__close"
            >
              <CloseWhiteIcon />
            </div>
          )}

          <UiLanguageFonts> {props.children}</UiLanguageFonts>
        </Box>
      </Modal>
    </>
  );
};

export const UiCustomPopup = (props) => {
  const PopupclassName = `df-commmon-modal ${props.className ?? ""}`;

  return (
    <>
      <Modal
        open={props.openModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            props.handleClose();
          }
        }}
        className="df-centerd-modal"
      >
        <Box className={PopupclassName}>
          <div className="df-overflow-scroll">
            {props.showCloseIcon && (
              <div
                data-testid="modal-close-icon"
                onClick={props.handleClose}
                className="df-centerd-modal__close"
              >
                <CloseWhiteIcon />
              </div>
            )}

            <UiLanguageFonts> {props.children}</UiLanguageFonts>
          </div>
        </Box>
      </Modal>
    </>
  );
};
